export default {
    view: "View more"
}